<section [class.expanded]="expanded">
  <kb-variable-heading [level]="headingLevel">
    <button type="button" class="accordion-panel-header-button" [attr.aria-expanded]="expanded" [attr.aria-controls]="panelContentId" [id]="panelHeaderId" (click)="toggle()">
      <ng-content select="kb-panel-header" />
      <kb-icon class="open-close-icon" [icon]="iconArrowDown" icon-center icon-uppercase />
    </button>
  </kb-variable-heading>

  <div class="content" role="region" [id]="panelContentId" [attr.aria-labelledby]="panelHeaderId" [@expandCollapse]="expanded ? 'expanded' : 'collapsed'">
    <ng-content select="kb-panel-content" />
  </div>
</section>
